import CreateHttpClient from './createTimetablesWebApiHttpClient';
import { AxiosInstance } from 'axios';

import { SchoolTerm } from '../models/term';

class TermApi {
    private httpClient: AxiosInstance;

    constructor() {
        this.httpClient = CreateHttpClient();
    }

    async GetTermsByCampusId(campusId: number) {
        const { data } = await this.httpClient.get(`/terms/campus/${campusId}`);
        return data;
    }

    async GetTermsBySchoolId(schoolId: number, sortBy?: string) {
        let endpoint = `/terms/school/${schoolId}`;
        if (sortBy) endpoint = `/terms/school/${schoolId}?sortBy=${sortBy}`;
        
        const { data } = await this.httpClient.get(endpoint);
        return data;
    }

    async AddNewTerm(term: SchoolTerm) {
        const { data } = await this.httpClient.post('/terms', term);
        return data;
    }

    async UpdateTerm(term: SchoolTerm) {
        const payload = {
            ...term,
        };
        const { data } = await this.httpClient.put(`/terms`, payload);
        return data;
    }
}

export default TermApi;
